export default __webpack_public_path__ + "static/media/uranium.0f612ac2.svg";